import { Jackpot } from '../../../../state/jackpots/jackpots.types';
import { ImageType } from '../../../../state/shared/games.types';

export const shouldShowDecimals = (jackpot: Jackpot, imageType: ImageType) =>
  jackpot &&
  (imageType !== 'square' ||
    jackpot.startAmount + jackpot.stepPerSecond < 1000000);
